import Inputmask from 'inputmask';

document.addEventListener('DOMContentLoaded', function () {
	const dateMask = new Inputmask('datetime', {
		alias: 'datetime',
		inputFormat: 'dd/mm/yyyy',
	});

	const dateFields = document.querySelectorAll('.om-form .date-field');

	for (const field of dateFields) {
		dateMask.mask(field);
	}
});
